import axios from 'axios';
import { CLIENT_REST_ROUTE } from '../routes/constants';
import { logError } from './utils';

const getUrl = () => CLIENT_REST_ROUTE.SELLER_NOTABLE_CLIENTS;

/** @type {import('./getNotableClients').GetNotableClients} */
export const getNotableClients = (sellerId) =>
    axios
        .post(getUrl(), { sellerId })
        .then(({ data }) => data)
        .catch((error) => {
            logError(`Failed to fetch notable client of "${sellerId}"`, { error });
            throw error;
        });
